import { BusinessHoursNode } from 'components/powerFlowShared/components/modals/businesshours/businesshours';
import { FlowNodeFilters } from 'components/powerFlowShared/components/nodeTypes/filters';
import { FlowNodeIntegration } from 'components/powerFlowShared/components/nodeTypes/integration';
import { NodeDataT, NodeT } from 'fable/flowEditor';

import { FlowEmailNodeIntentDetectionT } from '../components/nodeTypes';
import { FlowEmailNodeCloseT } from '../components/nodeTypes/close';
import { FlowEmailNodeContentT } from '../components/nodeTypes/content';
import { FlowEmailNodeInitT } from '../components/nodeTypes/init';
import { FlowEmailNodeQueueT } from '../components/nodeTypes/queue';
import { FlowEmailNodeReplyT } from '../components/nodeTypes/reply';

export enum SaveStatus {
  FAILED = -1,
  UNSAVED = 0,
  SAVING = 1,
  SAVED = 2,
}

export type FlowEmailAddFlowPayloadT = {
  flow: FlowEmailCreateFlowT;
};

export type FlowEmailUpdateFlowPayloadT = {
  flow: FlowEmailUpdateFlowT;
  id: string;
};

export type FlowEmailGetPayloadT = {
  email_address: string;
  id: string;
};

export type FlowEmailRemovePayloadT = FlowEmailGetPayloadT;

export type FlowEmailAddNodePayloadT = {
  node: NodeT;
};

export interface FlowEmailCreateFlowT
  extends Omit<
    NodeDataT<FlowEmailActionT[]>,
    'created_at' | 'id' | 'updated_at'
  > {
  channel: 'email';
  location: string;
}

export interface FlowEmailUpdateFlowT
  extends Omit<
    NodeDataT<FlowEmailActionT[]>,
    'channel' | 'created_at' | 'location' | 'updated_at' | 'updated_by'
  > {
  id: string;
  location: string | null;
  channel: 'email';
}

export type FlowEmailActionT =
  | FlowEmailNodeCloseT
  | FlowEmailNodeContentT
  | FlowEmailNodeInitT
  | FlowEmailNodeQueueT
  | FlowEmailNodeReplyT
  | FlowNodeFilters
  | FlowNodeIntegration
  | BusinessHoursNode
  | FlowEmailNodeIntentDetectionT;
